import { httpClient } from 'providers/clients/httpClient';
import { SiteNamespaces, SitePreferences, ScopeType } from '../SettingsContext';
import { CorePreferencesTypeResponse } from 'utility/types/dataProvider';

// -----------------------------------------------
// ----------------- Helpers ---------------------
// -----------------------------------------------
const generateDateVersion = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}.${month}.${day}`;
};

// -----------------------------------------------
// ------------ USERS PROVIDER -------------------
// -----------------------------------------------
export const userPreferencesProvider = {
  // [GET] /core/preferences/ Retrieve all the preferences for the current user on the site or global level.
  getUserPreferences: async (
    siteOrGlobal: ScopeType = 'site',
  ): Promise<CorePreferencesTypeResponse> => {
    try {
      const path = `/core/preferences/${siteOrGlobal}/`;

      const { status, data } = await httpClient({
        url: path,
        method: 'GET',
      });

      const result: CorePreferencesTypeResponse = {
        status: data?.status || status,
        data: data?.data,
      };

      return result;
    } catch (error) {
      console.error('[getUserPreferences] Error:', error);
      throw error;
    }
  },

  // [PUT] /core/preferences/ Update the preferences for the current user on the site or global level.
  updateUserPreferences: async (
    // TODO: add GlobalNamespaces type when needed.
    nameSpace: SiteNamespaces,
    preferences: SitePreferences,
    siteOrGlobal: ScopeType = 'site',
  ): Promise<CorePreferencesTypeResponse> => {
    try {
      const path = `/core/preferences/${siteOrGlobal}/${nameSpace}/`;

      const { data, status } = await httpClient({
        url: path,
        method: 'PUT',
        data: {
          version: generateDateVersion(),
          config: preferences,
        },
      });

      const result: CorePreferencesTypeResponse = {
        status: data?.status || status,
        data: data?.data,
      };

      return result;
    } catch (error) {
      console.error('[putUserPreferences] Error:', error);
      throw error;
    }
  },

  deleteSettingsNamespace: async (
    // TODO: add GlobalNamespaces type when needed.
    nameSpace: SiteNamespaces,
    siteOrGlobal: ScopeType,
  ): Promise<CorePreferencesTypeResponse> => {
    try {
      const path = `/core/preferences/${siteOrGlobal}/${nameSpace}/`;
      const { data, status } = await httpClient({
        url: path,
        method: 'DELETE',
      });

      const result: CorePreferencesTypeResponse = {
        status: data?.status || status,
        data: data?.data,
      };

      return result;
    } catch (error) {
      console.error('[deleteSettingsNamespace] Error:', error);
      throw error;
    }
  },
};

export default userPreferencesProvider;
